import {
  GET_ADDONS_FAILURE,
  GET_ADDONS_REQUEST,
  GET_ADDONS_SUCCESS,
  GET_ADDONS_TIMEOUT
} from '../constants/ActionTypes';
import { dispatchError, cachedFetchGet } from '../utils/fetch';
import { format } from 'date-fns';
import { parseISOLocal } from '../utils/date';
import { first } from '../utils';
import packageKey from '../utils/packageKey';
import getItemExpanded from './getItemExpanded';

function getAddOnsRequest(day) {
  return {
    type: GET_ADDONS_REQUEST,
    day
  };
}

function getAddOnsFailure(day, pkg, error, errors) {
  return {
    type: GET_ADDONS_FAILURE,
    day,
    pkg,
    error,
    errors
  };
}

function getAddOnsSuccess(day, pkg, addOns) {
  return {
    type: GET_ADDONS_SUCCESS,
    day,
    pkg,
    addOns,
    date: new Date(),
    timeout: setTimeout(getAddOnsTimeout, 5000)
  };
}

function getAddOnsTimeout() {
  return {
    type: GET_ADDONS_TIMEOUT
  };
}

export default function getAddOns() {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const {
        config,
        sale: {
          sale: { day, promoCode, packages }
        },
        inventory
      } = getState();

      dispatch(getAddOnsRequest(day));

      const date = parseISOLocal(day);
      const dateString = format(date, 'yyyyMMdd');

      // https://tickets-api-local.com:5001/api/items?startDate=08282019&startTime=000000&endDate=08282019&endTime=110000

      const moddablePkgs = Object.keys(packages).filter((/*pkgId*/) => {
        // const inventoryPkgs = inventory.packages[packageKey(day)];
        // const pkg = first(inventoryPkgs, p => p.item_id == pkgId);

        // TODO: find out if there's a way to determine if an item has mods before calling /items/mods
        return true;
      });

      if (moddablePkgs == null || moddablePkgs.length < 1) {
        dispatch(getAddOnsSuccess(day, null, null));
        return resolve();
      }

      return Promise.all(
        moddablePkgs.map(pkgId => {
          const inventoryPkgs = inventory.packages[packageKey(day)] || [];
          const pkg = first(inventoryPkgs, p => p.item_id == pkgId);
          if (pkg == null) return;

          // use qty from sale package, not inventory package
          pkg.qty = packages[pkgId].qty;

          return cachedFetchGet(config, 'items/mods', {
            startDate: dateString,
            startTime: '000000',
            endDate: dateString,
            endTime: '235959',
            item: pkg.item,
            mktgcode: promoCode,
            category: pkg.category,
            department: pkg.department,
            quantity: pkg.qty,
            headNode:
              config.headNode == null || config.headNode.trim() == ''
                ? null
                : config.headNode
          })
            .then(addOns => {
              dispatch(getAddOnsSuccess(day, pkg, addOns));
              dispatch(getItemExpanded(pkg));
            })
            .catch((...args) => {
              dispatchError(dispatch, getAddOnsFailure.bind(this, day, pkg))(
                ...args
              );

              reject(...args);
            });
        })
      ).then(resolve);
    });
}
